import React, { useEffect, useState } from "react"
import { useSelector, useDispatch } from "react-redux"

import { IDLE, PENDING } from "const"
import { MtTaskCommentCreate } from "server/models"
import { StateType } from "client/utils"
import {
    TaskObjectProps,
    StoreType,

    LoadAllTaskComments,
    LoadTaskCommentById,
    SaveTaskComment,
    DeleteTaskComment,

    setTaskCommentList,
} from "client/store"
import {
    Loader,
    Comments,
    EditCommentType,
    SaveCommentType,
    DeleteCommentType,
} from "client/components"

import { TaskCommentListWrapper } from "./styled"

const TaskComments = ({
    task,
}: TaskObjectProps) => {
    const commentList = useSelector((state: StoreType) => state.taskComment.commentList)
    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const [loadState, setLoadState] = useState<StateType>(IDLE)

    useEffect(() => {
        if (!task) return

        setLoadState(PENDING)
        LoadAllTaskComments(task.id).then((comments) => {
            setLoadState(IDLE)
            dispatch(setTaskCommentList(task.id, comments))
        })
    }, [task])

    const onEdit: EditCommentType = (activeComment, editCallback) => {
        LoadTaskCommentById(activeComment.id)
        .then((res) => editCallback(res))
    }

    const onSave: SaveCommentType = (comment, attachments, saveCallback) => {
        const newCommentData: MtTaskCommentCreate = {
            taskId: task.id,
            comment: comment.comment,
            author: comment.author,
        }

        SaveTaskComment(
            comment.id,
            newCommentData,
            attachments,
            lang,
        ).then((res) => {
            if (!res.validation) {
                LoadAllTaskComments(task.id).then((comments) => {
                    dispatch(setTaskCommentList(task.id, comments))
                    saveCallback(res.validation)
                })
            } else {
                saveCallback(res.validation)
            }
        })
    }

    const onDelete: DeleteCommentType = (activeComment, deleteCallback) => {
        DeleteTaskComment(activeComment.id, task.id).then((removedRows) => {
            if (removedRows === 1) {
                dispatch(setTaskCommentList(task.id, commentList[task.id].filter((row) => row.id !== activeComment.id)))
                deleteCallback()
            }
        })
    }

    return (
        <TaskCommentListWrapper>
            {
                loadState === PENDING
                && <Loader />
            }

            <Comments
                comments={commentList[task.id]}
                task={task}
                onEdit={onEdit}
                onSave={onSave}
                onDelete={onDelete}
            />
        </TaskCommentListWrapper>
    )
}
export default TaskComments
